import { useTranslation } from "react-i18next";

import { useHistorySource } from "./historySource";
import { useSigned } from "./useSigned";
import type { CaptainBillingHistorySource, CaptainTokenBalance } from "../../types";
import { availableAfter, capLeftAfter } from "../../utils";

import { cn } from "@/lib/utils/cn";
import { useValueFormatter } from "@/utils/useValueFormatter";

const LEFT_AFTER: Record<CaptainBillingHistorySource | "all", (balance: CaptainTokenBalance) => number> = {
  all: availableAfter,
  cap: capLeftAfter,
  topUp: (balance) => balance.topUpBalanceTokens,
};

type BalanceAsideProps = {
  balanceAfter: CaptainTokenBalance;
  delta?: number;
};

export function BalanceAside({ balanceAfter, delta }: BalanceAsideProps) {
  const { t } = useTranslation();
  const { format } = useValueFormatter();
  const signed = useSigned();
  const view = useHistorySource() ?? "all";
  const left = LEFT_AFTER[view](balanceAfter);

  return (
    <>
      {delta !== undefined && delta !== 0 && (
        <span className={cn("text-sm font-semibold tabular-nums", delta > 0 ? "text-success" : "text-foreground")}>
          {signed(delta)}
        </span>
      )}
      <span className="text-xs text-muted-foreground tabular-nums">
        {t(`captainBilling.history.after.${view}`, { tokens: format(left, "decimal") })}
      </span>
    </>
  );
}
